import React from 'react';
import { useHistory } from 'react-router';
import { Button } from 'modules/v2/common/AtomicDesign/atoms';
import { getRoutePlansAndBillings } from 'modules/v2/routes/navigation';

interface CancellationBannerProps {
  scheduledCancelDate: string;
}

export const CancellationBanner: React.FC<CancellationBannerProps> = ({
  scheduledCancelDate,
}) => {
  const history = useHistory();

  const handleGoToBilling = () => {
    history.push(getRoutePlansAndBillings());
  };

  const formattedDate = new Date(scheduledCancelDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="fixed top-[62px] left-0 right-0 bg-primary-50 border-b border-primary-200 h-[46px] z-[998] flex items-center justify-center text-sm px-4">
      <div className="flex items-center gap-4">
        <span className="font-medium text-neutral-800">
          Your subscription is scheduled to be canceled on{' '}
          <span className="font-semibold">{formattedDate}</span>
        </span>
        <Button type="primary" size="xs" onClick={handleGoToBilling}>
          Manage subscription
        </Button>
      </div>
    </div>
  );
};
